/* Jaspa extras: wishlist (saved on the shopper's device) and the
   "bundle in progress" reminder. Separate from jaspa.js so that file stays
   inside its size budget. No dependencies. */
(function () {
  'use strict';
  /* the loader tag is printed by every jaspa section, so make sure this runs once */
  if (window.__jaspaExtras) return;
  window.__jaspaExtras = true;
  function get(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ================= wishlist ================= */
  var WKEY = 'jWish';
  function list() { return get(WKEY, []).filter(function (x) { return x && x.h; }); }
  function has(h) { return list().some(function (x) { return x.h === h; }); }
  function toggle(h, picks) {
    var l = list(), i = l.findIndex(function (x) { return x.h === h; });
    if (i > -1) l.splice(i, 1); else l.unshift({ h: h, p: picks ? 1 : 0, at: Date.now() });
    put(WKEY, l.slice(0, 60));
    return i === -1;
  }
  function paintHearts() {
    document.querySelectorAll('[data-j-wish]').forEach(function (b) {
      var on = has(b.dataset.jWish);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = b.querySelector('[data-j-wish-label]');
      if (lab) lab.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
    var n = list().length;
    document.querySelectorAll('[data-j-wishcount]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
  }
  /* a heart in the header, next to the cart */
  function headerLink() {
    if (document.querySelector('.j-wishlink')) return;
    var cart = document.querySelector('.section-header [href$="/cart"], .section-header [class*="cart"]');
    var host = cart && cart.closest('.header__icons, [class*="header__icons"]');
    if (!host) return;
    var a = document.createElement('a');
    a.className = 'j-wishlink'; a.href = '/pages/wishlist'; a.setAttribute('aria-label', 'Your wishlist');
    a.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.4 4.5 6.9 4.5c2 0 3.6 1.1 5.1 3 1.5-1.9 3.1-3 5.1-3 3.5 0 5.5 3.4 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg><i data-j-wishcount hidden>0</i>';
    var before = cart.closest('a, button, div') || cart;
    while (before.parentElement && before.parentElement !== host) before = before.parentElement;
    host.insertBefore(a, before.parentElement === host ? before : null);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-j-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = toggle(b.dataset.jWish, b.hasAttribute('data-j-wish-picks'));
    if (on) { b.classList.add('j-wish--pop'); setTimeout(function () { b.classList.remove('j-wish--pop'); }, 400); }
    paintHearts();
    var grid = document.querySelector('[data-j-wishgrid]');
    if (grid && !on) { var card = b.closest('.j-card'); if (card) card.remove(); emptyState(); }
  });

  /* the wishlist page */
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function emptyState() {
    var grid = document.querySelector('[data-j-wishgrid]'), empty = document.querySelector('[data-j-wishempty]');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  }
  function renderPage() {
    var grid = document.querySelector('[data-j-wishgrid]');
    if (!grid) return;
    var l = list();
    if (!l.length) { emptyState(); return; }
    Promise.all(l.map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (p) { return { it: it, p: p }; });
    })).then(function (rows) {
      var gone = [];
      grid.innerHTML = rows.map(function (row) {
        var p = row.p, it = row.it;
        if (!p) { gone.push(it.h); return ''; }
        var v = (p.variants || []).find(function (x) { return x.available; }) || p.variants[0];
        var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        var url = '/products/' + p.handle;
        var btn;
        if (!p.available) btn = '<button type="button" class="j-card__add" disabled>Sold out</button>';
        else if (it.p || p.variants.length > 1) btn = '<a class="j-card__add" href="' + url + '">Choose</a>';
        else btn = '<button type="button" class="j-card__add" data-j-wishadd="' + v.id + '">Add to cart</button>';
        var price = p.compare_at_price > p.price ? money(p.price) + ' <s>' + money(p.compare_at_price) + '</s>' : money(p.price);
        return '<div class="j-card">' +
          '<button type="button" class="j-wish is-on" data-j-wish="' + esc(p.handle) + '"' + (it.p ? ' data-j-wish-picks="1"' : '') + ' aria-label="Remove from wishlist" aria-pressed="true">♥</button>' +
          '<a class="j-card__media" href="' + url + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
          '<div class="j-card__i"><h3><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<div class="j-card__row"><span class="j-card__price">' + price + '</span>' + btn + '</div></div></div>';
      }).join('');
      if (gone.length) put(WKEY, list().filter(function (x) { return gone.indexOf(x.h) === -1; }));   /* products that no longer exist */
      emptyState(); paintHearts();
    });
  }
  /* add to cart from the wishlist page or the wishlist pop-up */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-j-wishadd]');
    if (!b) return;
    b.disabled = true; var label = b.textContent; b.textContent = 'Adding';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.jWishadd), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); b.textContent = 'Added';
        if (wd && wd.open) wd.close();
        document.dispatchEvent(new CustomEvent('jaspa:cart:added')); })
      .catch(function () { b.textContent = 'Try again'; })
      .then(function () { setTimeout(function () { b.disabled = false; b.textContent = label; }, 1600); });
  });

  /* ================= wishlist pop-up (same panel as the cart) ================= */
  var wd = null;
  function fetchAll() {
    return Promise.all(list().map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (p) { return { it: it, p: p }; });
    }));
  }
  function drawWish() {
    var n = list().length;
    var head = '<header class="j-cart__head"><b>Your wishlist (' + n + ')</b>' +
      '<button type="button" class="j-cart__x" data-j-wd-close aria-label="Close wishlist">&times;</button></header>';
    if (!n) {
      wd.firstChild.innerHTML = head + '<div class="j-cart__empty"><div><div style="font-size:40px">💖</div>' +
        '<p><b>Nothing saved yet</b><br>Tap the heart on anything you love and it will wait for you here.</p>' +
        '<a class="j-btn" href="/collections/all">Start shopping</a></div></div>';
      return;
    }
    if (!wd.querySelector('.j-cart__items')) wd.firstChild.innerHTML = head + '<div class="j-cart__items"><p class="j-wd__load">Loading your saved items…</p></div>';
    fetchAll().then(function (rows) {
      var html = rows.map(function (row) {
        var p = row.p, it = row.it; if (!p) return '';
        var ok = (p.variants || []).filter(function (x) { return x.available && !/sold out/i.test(x.title); });
        var url = '/products/' + p.handle;
        var img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_140x$1$2') : '';
        var btn;
        if (!p.available || !ok.length) btn = '<span class="j-wd__out">Sold out</span>';
        else if (it.p || p.variants.length > 1) btn = '<a class="j-wd__add" href="' + url + '">Choose options</a>';
        else btn = '<button type="button" class="j-wd__add" data-j-wishadd="' + ok[0].id + '">Add to cart</button>';
        var price = p.compare_at_price > p.price ? money(p.price) + ' <s>' + money(p.compare_at_price) + '</s>' : money(p.price);
        return '<div class="j-cart__item"><a href="' + url + '">' + (img ? '<img src="' + esc(img) + '" width="70" height="70" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="j-cart__info"><a href="' + url + '"><b>' + esc(p.title) + '</b></a><span>' + price + '</span>' +
          '<div class="j-cart__row">' + btn + '<button type="button" class="j-cart__remove" data-j-wd-remove="' + esc(p.handle) + '">Remove</button></div></div></div>';
      }).join('');
      wd.firstChild.innerHTML = head + '<div class="j-cart__items">' + html + '</div>' +
        '<footer class="j-cart__foot"><a class="j-btn j-wd__all" href="/pages/wishlist">View my full wishlist</a>' +
        '<a class="j-cart__cont" href="#" data-j-wd-close>Keep shopping</a></footer>';
    });
  }
  function openWish() {
    if (!wd) {
      wd = document.createElement('dialog');
      wd.className = 'j-cart j-wd'; wd.setAttribute('aria-label', 'Your wishlist');
      wd.innerHTML = '<div class="jaspa"></div>';
      var st = document.createElement('style');
      st.textContent = '.j-wd__add{all:unset;cursor:pointer;font-weight:800;font-size:12.5px;background:#E85FAE;color:#fff!important;border-radius:99px;padding:8px 14px;box-shadow:0 3px 0 #C93B8E}' +
        '.j-wd__add:disabled{opacity:.6}.j-wd__out{font-weight:800;font-size:12.5px;color:#9A6E8A}' +
        '.j-wd .j-cart__info span{font-weight:700;color:#4A1D3A;margin-top:2px}.j-wd .j-cart__info s{opacity:.55;font-weight:600}' +
        '.j-wd .j-cart__remove{margin-top:0}.j-wd .j-wd__all{display:block;text-align:center;background:#E85FAE;color:#fff!important;font-weight:800;font-size:15px;border-radius:99px;padding:14px 18px;text-decoration:none;box-shadow:0 5px 0 #C93B8E}.j-wd__load{padding:30px 0;text-align:center;color:#7A4A66}' +
        '.j-wd .j-cart__empty p{margin:10px 0 0;color:#7A4A66}';
      document.head.appendChild(st);
      document.body.appendChild(wd);
      wd.addEventListener('click', function (e) {
        if (e.target === wd) return wd.close();
        if (e.target.closest('[data-j-wd-close]')) { e.preventDefault(); return wd.close(); }
        var rm = e.target.closest('[data-j-wd-remove]');
        if (rm) { toggle(rm.dataset.jWdRemove); paintHearts(); drawWish(); }
      });
    }
    drawWish();
    if (!wd.open) wd.showModal();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.j-wishlink');
    if (!a || e.metaKey || e.ctrlKey || location.pathname.indexOf('/pages/wishlist') === 0) return;
    e.preventDefault(); openWish();
  });

  /* ================= bundle in progress ================= */
  function wip() {
    var best = null;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k.indexOf('jbp:') !== 0) continue;
        var s = get(k, null);
        if (!s || !s.f || !s.u || Date.now() - (s.at || 0) > 30 * 864e5) continue;
        if (!best || s.at > best.at) best = s;
      }
    } catch (e) {}
    return best;
  }
  function wipBanner() {
    var drawer = document.querySelector('[data-j-cart]');
    if (!drawer) return;
    var old = drawer.querySelector('.j-cart__wip'); if (old) old.remove();
    var s = wip();
    if (!s || location.pathname.indexOf(s.u) === 0) return;
    var head = drawer.querySelector('.j-cart__head');
    if (!head) return;
    var a = document.createElement('a');
    a.className = 'j-cart__wip'; a.href = s.u;
    var doneAll = s.f >= s.n;
    a.innerHTML = '<span aria-hidden="true">🎁</span><span><b>' + (doneAll ? 'Your bundle is ready' : 'Bundle in progress') + '</b>' +
      esc(s.t) + ': ' + s.f + ' of ' + s.n + ' picked</span><em>' + (doneAll ? 'Add it' : 'Finish it') + ' →</em>';
    head.insertAdjacentElement('afterend', a);
  }

  /* ================= mobile menu ================= */
  /* The menu opens beneath the real header, so tell the CSS where the header ends,
     and let the hamburger close the menu as well as open it. */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('.js-menu-drawer-trigger');
    if (!trig) return;
    var hdr = document.querySelector('.header-wrapper') || trig;
    document.documentElement.style.setProperty('--j-menu-top', Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px');
    var drawer = document.querySelector('sht-menu-drwer');
    if (drawer && drawer.classList.contains('active')) {
      e.preventDefault(); e.stopPropagation();
      var c = drawer.querySelector('.js-menu-drawer-btn-close');
      if (c) c.click();
    }
  }, true);

  /* long auto-scrolling strips only run while they are on screen */
  function pauseOffscreen() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.style.animationPlayState = e.isIntersecting ? '' : 'paused'; });
    }, { rootMargin: '120px 0px' });
    document.querySelectorAll('.j-lovers__track, .j-revtrain__track, .j-ticker__track').forEach(function (t) { io.observe(t); });
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    }, { rootMargin: '60px 0px' });
    document.querySelectorAll('.j-vtabs').forEach(function (t) { t.classList.add('is-off'); io2.observe(t); });
  }

  /* ================= swipeable product gallery ================= */
  function swipeGallery() {
    document.querySelectorAll('[data-j-gallery]').forEach(function (g) {
      var main = g.querySelector('.j-main'), img = g.querySelector('[data-j-main]');
      var thumbs = [].slice.call(g.querySelectorAll('[data-j-thumb]'));
      if (!main || !img || thumbs.length < 2) return;
      if (!document.getElementById('j-gswipe-css')) {
        var st = document.createElement('style'); st.id = 'j-gswipe-css';
        st.textContent = '.j-gallery .j-main{touch-action:pan-y;overflow:hidden}.j-gallery .j-main img[data-j-main]{will-change:transform}' +
          '.j-gdots{display:flex;justify-content:center;gap:7px;margin-top:10px}.j-gdots i{width:8px;height:8px;border-radius:50%;background:#F2DCE9;transition:background .2s,transform .2s}.j-gdots i.is-on{background:#E85FAE;transform:scale(1.25)}' +
          '.j-garrow{position:absolute;top:50%;z-index:3;width:44px;height:44px;margin-top:-22px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#4A1D3A;font-size:22px;font-weight:800;line-height:1;cursor:pointer;box-shadow:0 3px 0 #F2DCE9;display:grid;place-items:center}' +
          '.j-garrow--p{left:10px}.j-garrow--n{right:10px}@media(max-width:880px){.j-garrow{display:none}}@media(min-width:881px){.j-gdots{display:none}}';
        document.head.appendChild(st);
      }
      var dots = document.createElement('div'); dots.className = 'j-gdots'; dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = thumbs.map(function () { return '<i></i>'; }).join('');
      main.insertAdjacentElement('afterend', dots);
      function cur() { var i = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; }); return i < 0 ? 0 : i; }
      function paint() { var c = cur(); [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === c); }); }
      var busy = false;
      function go(dir) {
        if (busy) return; busy = true;
        var n = (cur() + dir + thumbs.length) % thumbs.length;
        img.style.transition = 'transform .16s ease, opacity .16s ease';
        img.style.transform = 'translateX(' + (-dir * 40) + '%)'; img.style.opacity = '0';
        setTimeout(function () {
          thumbs[n].click();
          img.style.transition = 'none'; img.style.transform = 'translateX(' + (dir * 40) + '%)';
          var show = function () {
            img.style.transition = 'transform .2s ease, opacity .2s ease'; img.style.transform = ''; img.style.opacity = '';
            setTimeout(function () { busy = false; }, 210);
          };
          if (img.complete) requestAnimationFrame(show); else { img.addEventListener('load', show, { once: true }); setTimeout(show, 450); }
        }, 165);
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(paint, 0); }); });
      [['p', -1, '‹', 'Previous image'], ['n', 1, '›', 'Next image']].forEach(function (a) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'j-garrow j-garrow--' + a[0];
        b.textContent = a[2]; b.setAttribute('aria-label', a[3]); b.addEventListener('click', function () { go(a[1]); });
        main.appendChild(b);
      });
      var x0 = null, y0 = 0, dx = 0, horiz = false;
      main.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horiz = false; }, { passive: true });
      main.addEventListener('touchmove', function (e) {
        if (x0 === null || busy) return;
        dx = e.touches[0].clientX - x0; var dy = e.touches[0].clientY - y0;
        if (!horiz && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) horiz = true;
        if (horiz) { img.style.transition = 'none'; img.style.transform = 'translateX(' + dx * 0.6 + 'px)'; }
      }, { passive: true });
      main.addEventListener('touchend', function () {
        if (x0 === null) return; x0 = null;
        if (horiz && Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        else { img.style.transition = 'transform .15s ease'; img.style.transform = ''; }
      });
      paint();
    });
  }

  function init() {
    headerLink(); paintHearts(); renderPage(); wipBanner(); pauseOffscreen(); swipeGallery();
    var drawer = document.querySelector('[data-j-cart]');
    if (drawer) new MutationObserver(function () {
      if (!drawer.querySelector('.j-cart__wip')) wipBanner();
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Predictive search: Shine only downloads its search script when the search box
   opens, so letters typed before it arrives show no suggestions. Once that script
   has loaded, replay the current text so the suggestions appear for the first try. */
(function () {
  var done = false;
  function replay() {
    if (done) return;
    var inp = document.getElementById('predictiveSearch_Input');
    if (!inp) return;
    done = true;
    setTimeout(function () {
      if (inp.value.trim()) inp.dispatchEvent(new Event('input', { bubbles: true }));
    }, 50);
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.tagName === 'SCRIPT' && (n.src || '').indexOf('component-predictive-search') > -1) {
          n.addEventListener('load', replay);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
